import React, { Component } from 'react';
import Joi from "joi-browser";
import { toast } from 'react-toastify';
import { connect } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactComponent as Xclose } from "assets/images/icons/project-icons/xclose.svg";
import bento from "assets/images/logos/bento.svg";
import * as info from "store/entities/settingsInfo/action";
import * as integrations from "store/entities/integrations/action";

class BentoLoginModal extends Component {

    state = {
        bentoParams: {
            username: "",
            password: "",
            thirdParty: "bento",
        }
    }


    formChange = (e) => {
        const formValue = {...this.state.bentoParams};
        formValue[e.currentTarget.name] = e.currentTarget.value;
        this.setState({bentoParams: formValue});
    }
    

    schema = {
        username: Joi.string().required().label("Username").error(errors => {
            errors.forEach(err => {
                switch (err.type) {
                    case "any.empty":
                        err.message = "Please enter your email address / phone number";
                        break;
                    case "string.email":
                        err.message = "Please enter your valid email address / phone number";
                        break;
                    default:
                        break;
                }
            });
            return errors;
        }),
        password: Joi.string().required().label("Password").error(errors => {
            errors.forEach(err => {
                switch (err.type) {
                    case "any.empty":
                        err.message = "Please enter your password";
                        break;
                    default:
                        break;
                }
            });
            return errors;
        }),
    }


    validate = () => {
        const options = { abortEarly: false, allowUnknown: true };
        const result = Joi.validate(this.state.bentoParams, this.schema, options);
        // console.log(result);
        const error = result.error;
        if (!error) return null;
    
        const errors = {};
        for (let item of result.error.details){
            errors[item.path[0]] = item.message;
        }
        return errors;
    };


    submitBentoForm = async e => {
        e.preventDefault();
        const errors = this.validate();
        this.setState({errors: errors || {}});
        if (errors){
            // console.log(errors);
            for (var x in errors) {
                toast.error(errors[x]);
            };
            return;
        }
        else{
            const {bentoParams} = this.state;
            this.props.bentoLogin(bentoParams).then(() => {
                const { bentoLoginResponse } = this.props;
                if (bentoLoginResponse.status === "success"){
                    this.props.getInfo();
                    this.props.toggleLoginModalSidebar();
                }
            });
        }
    }


    componentDidMount() {
        this.props.getInfo();
    }


    render() { 
        const { bentoParams } = this.state;
        const { showLoginModal, bentoLoginLoading } = this.props;

        return ( 
            <>

                <div className={"w-full sm:max-w-sm sm:w-screen sm:h-screen bg-white bg-modal fixed z-50 top-0 bottom-0 shadow-xl animate " + (showLoginModal ? "right-0" : "-right-full")}>
                    <div className="w-full h-full p-8 pb-32 overflow-auto overscroll-contain">

                        <div className="flex justify-between">
                            <div></div>
                            <div onClick={() => this.props.toggleLoginModalSidebar()} className="w-8 h-8 flex border group hover:bg-red-400 hover:border-red-400 border-gray-700 rounded-lg cursor-pointer">
                                <Xclose className="customizeSVG group-hover:text-white m-auto" />
                            </div>
                        </div>

                        <form onSubmit={this.submitBentoForm} className="mt-6 sm:mr-10">
                            <div>
                                <img src={bento} alt="Bento" className="w-24 object-contain" />
                            </div>

                            <div className="mt-10">

                                <div className="text-xl font-bold">
                                    Login to your company
                                </div>
                                <div className="mt-1 text-sm">
                                    Enter your details below to access your account
                                </div>

                                <div className="mt-10">
                                    <div className="form-group">
                                        <label>
                                            Username
                                            <span className="form-input-required">*</span>
                                        </label>
                                        <input type="text" name="username" placeholder="Email Address / Phone Number" className="form-input" value={bentoParams.username} onChange={this.formChange} />
                                    </div>

                                    <div className="form-group">
                                        <label>
                                            Password
                                            <span className="form-input-required">*</span>
                                        </label>
                                        <input type="password" name="password" placeholder="XXXXXXXXXX" className="form-input" value={bentoParams.password} onChange={this.formChange} />
                                    </div>
                                </div>

                                {/* <hr className="my-10" /> */}

                                <div className="my-6 checkbox">
                                    <label className="cursor-pointer inline-block">
                                        <input type="checkbox" className="w-5 h-5 mr-2 form-checkbox float-left" required />
                                        <div className="text-sm text-gray-500 overflow-hidden">
                                            {/* 
                                            Inline with our <br />
                                            <Link to={{pathname:"https://earnipay.com/terms"}} target="_blank" className="font-bold text-gray-900 hover:underline">Terms and Conditions</Link>
                                            , and &nbsp;
                                            <Link to={{pathname:"https://earnipay.com/privacy-policy"}} target="_blank" className="font-bold text-gray-900 hover:underline">Privacy Policy</Link>
                                            ,
                                             */}
                                            I understand that Earnipay ONLY use my Bento login information to fetch employees from Bento, and post deductions to Bento.
                                        </div>
                                    </label>
                                </div>

                            </div>

                            <button type="submit" className="btn btn-ep-primary btn-block btn-lg" disabled={bentoLoginLoading}>
                                <FontAwesomeIcon icon="circle-notch" spin className={"text-xl mr-2 " + (bentoLoginLoading?"inline":"hidden")} />
                                Login
                            </button>
                        </form>
                    
                    </div>
                </div>
                <div onClick={() => this.props.toggleLoginModalSidebar()} className={"fixed z-10 inset-0 bg-black bg-opacity-80 animate " + (showLoginModal ? "block" : "hidden")}></div>

            </>
        );
    }
}



const mapStateToProps = (state) => ({
    companyInfoLoading: state.entities.settingsInfo.getLoading,
    companyInfo: state.entities.settingsInfo.companyInfo.company,
    bentoLoginLoading: state.entities.integrations.bentoLoginLoading,
    bentoLoginResponse: state.entities.integrations.bentoLoginResponse,
});

const mapDispatchToProps = (dispatch) => ({
    getInfo: () => dispatch(info.getInfo()),
    bentoLogin: (params) => dispatch(integrations.bentoLogin(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BentoLoginModal);